// node_modules
import { FC, useContext } from "react";
// Types
import { TTechnology } from "Types";
// Components
import { LetteredUserCircle, TechnologyRate, TechnologyRatesSummaryIcon } from "Components";
// styles
import styles from './technologyRatesModal.module.scss';
// Contexts
import { AuthContext } from "Stores";

type TTechnologyRatesModalProps = {
    technology: TTechnology,
    handleOnMouseEnterModal: () => void,
    handleOnMouseLeaveModal: () => void
}

export const TechnologyRatesModal: FC<TTechnologyRatesModalProps> = ({ technology, handleOnMouseEnterModal, handleOnMouseLeaveModal }: TTechnologyRatesModalProps) => {
    // Contexts
    const { authState } = useContext(AuthContext);

    // Logic
    const getRatersCount = () => {
        let ratersCount: number = 0;
        if (!technology.rates) return ratersCount;
        if (technology.rates.currentUserRate) ratersCount++;
        if (technology.rates.userRates && technology.rates.userRates.length >= 1) ratersCount += technology.rates.userRates.length;
        return ratersCount;
    };

    const areThereAnyRates = (): boolean => {
        return technology.rates &&
            (technology.rates.currentUserRate ||
                (technology.rates.userRates && technology.rates.userRates.length >= 1)) ? true : false;
    };

    return (
        <div onMouseEnter={handleOnMouseEnterModal} onMouseLeave={handleOnMouseLeaveModal} className={styles.technologyRatesModal}>
            {!technology.rates || !areThereAnyRates() ?
                <div className={styles.technologyRateSummary}>
                    <div className={styles.starIconSummaryContainer}>
                        <TechnologyRatesSummaryIcon technology={technology} />
                    </div>
                    <span>No ratings</span>
                </div>
                :
                <div className={styles.technologyRateSummary}>
                    <div className={styles.starIconSummaryContainer}>
                        <TechnologyRatesSummaryIcon technology={technology} />
                    </div>
                    <span>
                        {technology.rates.averageRate} ({getRatersCount()})
                    </span>
                </div>
            }
            <div className={styles.technologyRateContainer}>
                <div className={styles.technologyRateRow}>
                    <div className={styles.technologyRateUser}>
                        <div className={styles.userCircleContainer}>
                            <LetteredUserCircle username={authState.userEmail} />
                        </div>
                        <div className={styles.currentUser}>You</div>
                    </div>
                    <TechnologyRate additionalClassName={styles.technologyUserRatesContainer} techRate={technology.rates?.currentUserRate} technology={technology} isEditMode={true} />
                </div>
                {technology.rates &&
                    technology.rates.userRates &&
                    technology.rates.userRates.length >= 1 ?
                    technology.rates.userRates.map((userRate, index) => {
                        return (
                            <div className={styles.technologyRateRow} key={index}>
                                <div className={styles.technologyRateUser}>
                                    <div className={styles.userCircleContainer}>
                                        <LetteredUserCircle username={userRate.userName} />
                                    </div>
                                </div>
                                <TechnologyRate additionalClassName={styles.technologyUserRatesContainer} techRate={userRate} technology={technology} isEditMode={false} />
                            </div>
                        );
                    })
                    :
                    <></>
                }
            </div>
        </div>
    );
};